import type {
  AccountType,
  AccountTypeFlags,
} from "../../convex/schemas/validators/enums.lib";

export interface StatedAccountUses {
  buy: boolean;
  sell: boolean;
}

function statedAccountTypes(stated: StatedAccountUses): AccountType[] {
  const accountTypes: AccountType[] = [];
  if (stated.buy) accountTypes.push("buyer");
  if (stated.sell) accountTypes.push("vendor");
  return accountTypes;
}

export function isUndecidedProspect(
  flags: AccountTypeFlags | undefined,
  stated?: StatedAccountUses,
): boolean {
  if (!flags?.prospect || flags.buyer || flags.vendor || flags.freightCarrier) return false;
  return !stated || (!stated.buy && !stated.sell);
}

export function resolveAccountTypes(
  flags: AccountTypeFlags | undefined,
  legacyAccountType: AccountType | undefined,
  stated?: StatedAccountUses,
): AccountType[] {
  const accountTypes: AccountType[] = [];
  if (flags?.buyer) accountTypes.push("buyer");
  if (flags?.vendor) accountTypes.push("vendor");
  if (flags?.freightCarrier) accountTypes.push("freight_carrier");
  if (accountTypes.length === 0 && flags?.prospect) {
    const statedTypes = stated ? statedAccountTypes(stated) : [];
    accountTypes.push(...(statedTypes.length > 0 ? statedTypes : (["buyer", "vendor"] as const)));
  }
  if (accountTypes.length === 0 && legacyAccountType && flags === undefined) {
    accountTypes.push(legacyAccountType);
  }
  return accountTypes;
}

export function canHoldPayoutAccount(accountTypes: readonly AccountType[]): boolean {
  return accountTypes.includes("buyer") || accountTypes.includes("vendor");
}
